module.exports = __webpack_public_path__ + "epdf-app/dashboard/depositor-confirm/depositor-confirm-3KD6-Qo6.html";